/* eslint-disable */
export default {
  buttons: {
    new: 'Yeni',
    save: 'Kaydet',
    delete: 'Sil',
    update: 'Güncelle',
    edit: 'Düzenle',
    clear: 'Temizle',
    details: 'Detaylar',
    done: 'Tamamla',
    cancel: 'İptal',
    refresh: 'Yenile',
    print: 'Yazdır',
    openNewCampaign: 'Yeni Kampanya Aç',
    startDrawingControl: 'Sıra Tespit Listesi Kontrol Süreci Başlat'
  },
  navbar: {
    someaction: 'İşlemler',
    action: 'İşlem',
    english: 'İngilizce',
    turkish: 'Türkçe',
    profile: 'Kullanıcı Profili',
    screenfull: 'Tam Ekran',
    size: 'Yazı Büyüklüğü',
    languageChanged: 'Dil başarı ile değiştirildi',
    dashboard: 'Dashboard',
    logOut: 'Çıkış'
  },
  usermenu: {
    name: 'Ad Soyad',
    email: 'E-Mail',
    telno: 'Telefon Numarası'
  },
  tagsView: {
    close: 'Kapat',
    closeOthers: 'Diğerlerini Kapat',
    closeAll: 'Hepsini Kapat',
    refresh: 'Yenile'
  },
  route: {
    dashboard: 'Dashboard',
    service: 'Servis Kayıt',
    servicePortfolio: 'Servis Portföyü',
    dms: 'Döküman Yönetimi',
    portfolioTransfer: 'Portföy Transferi',
    callCenterUpload: 'İletişim Merkezi',
    formdatalist: 'Müşteri Form Veri Transferi',
    quickPersonCreate: 'Hızlı Müşteri',
    login: 'Giriş',
    agentPortfolio: 'Agent',
    relationCreate: 'İlişki Tanımı',
    relationPatternCreate: 'İlişki Kalıbı Tanımı',
    portfolio: 'Portföy',
    crmAdmin: 'Müşteri Yönetim',
    references: 'Referanslar',
    home: 'Anasayfa',
    createPolicy: 'Yetkilendirme',
    parameterIncome: 'Gelir Tanımı',
    parameterSegment: 'Segment Tanımı',
    parameterRelation: 'Muhatap İlişki Tanımı',
    parameterClassification: 'Sınıflandırma Tanımı',
    parameterGeo: 'Coğrafi Tanım',
    parameterContactMechPurposeType: 'İletişim Amaç Tanımı',
    personCreate: 'Kişi',
    personList: 'Muhatap Listeleme',
    portfolioList: 'Portföy Listesi',
    portfolioBranchMapList: 'Şube Portföy İlişkisi ',
    createPartyInformalOrganization: 'Organizasyon',
    personEdit: 'Gerçek Kişi İzleme',
    personDashboard: 'Müşteri Dashboard',
    productCard: 'Finansman Planı Kartı',
    workingday: 'Çalışma Günü',
    revisionPrescreening: 'Revizyon Ön İnceleme',
    tasklist: 'Görev Listesi',
    templatelist: 'Şablon Listesi',
    drawingList: 'Sıra Tespiti Belirleme',
    drawingDetailsTitle: 'Sıra Tespiti Belirleme Gruplar',
    drawingGroupDetailsTitle: 'Sıra Tespiti Belirleme Grup Listesi',
    templatecreate: 'Yeni Şablon Oluştur',
    advantagelist: 'Insiyatif Tanımı',
    templateedit: 'Şablon Güncelleme',
    processlist: 'Süreç Listesi',
    processcreate: 'Süreç Başlat',
    bpm: 'İş Süreçleri',
    newtaskslist: 'Yeni Görev Listesi',
    help: 'Yardım',
    revision: 'Revize',
    userprofile: 'Kişisel Bilgiler',
    editprofile: 'Güncelle',
    settings: 'Ayarlar',
    templateview: 'Şablon',
    process: 'Süreç',
    financemanagement: 'Finansman Planı Yönetim',
    productdefinition: 'Finansman Planı İçerik Tanımı',
    salewizard: 'Satış',
    campaignlist: 'Kampanya Tanımı',
    advancelist: 'Peşinat Avantaj Tanımı',
    grouplist: 'Grup Tanımı',
    packagelist: 'Paket Tanımı',
    referencerulelist: 'Referans Kural Tanımı',
    versionlist: 'Versiyon Tanımı',
    campaignusagelist: 'Kampanya Kullanım Listesi',
    usageview: 'Kullanım Durumu Listeleri',
    packageusagelist: 'Öncelik Kullanım Listesi',
    referenceusagelist: 'Referans Kullanım Listesi',
    proposallist: 'Teklif Listesi',
    transactionlist: 'Tahsilat Listesi',
    orderedproductdetails: 'Çekilişli Tasarruf Programı Detayı',
    finance: 'Finansman',
    orderedwizard: 'Çekilişli Hesaplama',
    freeplanwizard: 'Sebest Planlı Hesaplama',
    noFulFillmentPersonList: 'Kişiler',
    employee: 'Çalışan',
    orderedproductlist: 'Çekilişli Finansman Planı Tanımı',
    branchDrawingList: 'Şube Sıra Tespiti Müşteri Lİstesi',
    freeplanproductdetails: 'Müşteri Bazlı Tasarruf Programı Detayı',
    freeplanproductlist: 'Müşteri Bazlı Finansman Planı Tanımı',
    detailview: 'Kampnya İzleme',
    hr: 'İnsan Kaynakları',
    newprocess: 'Yeni Süreç',
    roleCreate: 'Görev',
    departmentCreate: 'Departman',
    profile: 'Profil',
    usersettings: 'Kullanıcı Ayarları',
    logOut: 'Çıkış',
    crm: 'Müşteri',
    createPerson: 'Muhatap Ekle',
    newtask: 'Görev Ekle',
    positionTypeDetails: 'Görev Türü Detayı',
    position: 'Pozisyon (Kadro)',
    positionType: 'Görev',
    positionDetails: 'Pozisyon (Kadro) Detayı',
    organization: 'İyi Finans Organizasyon Şeması',
    personDetails: 'Çalışan Kartı',
    internalOrganizations: 'Organizasyonlar',
    internalOrganizationDetails: 'Organizasyon Detayları',
    we: 'Varlık Yönetimi',
    inventoryItem: 'Envanter',
    fixedAsset: 'Varlıklar',
    weParameters: 'Parametreler',
    dmsParameters: 'Doküman Yönetim Sistemi',
    bpmtemplate: 'Süreç Yönetimi',
    manage: 'İş Yönetimi',
    performance: 'Performans Hedefleri',
    workPlanning: 'Odak'
  },
  performancelist: {
    employeeName: 'Çalışan',
    positionTypeName: 'Görev',
    PerformanceReviewItemTypeName: 'Hedef'
  },
  login: {
    title: 'HOŞ GELDİNİZ!',
    logIn: 'GİRİŞ',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    rememberMe: 'Beni Hatırla',
    header1: 'SIRA TESPİTLİ YÖNTEM',
    description1: 'Evinizi teslim alacağınız tarih noter huzurunda yapılan sıra tespitiyle belirlenir.İsteyen hiç peşinat ödemeden ev sahibi olabilir.',
    header2: 'SERBEST PLANLI YÖNTEM',
    description2: 'Evinizi teslim alacağınız tarihi kendiniz serbest olarak planlayacağınız ödemelerinize göre belirleyebilirsiniz.',
    header3: 'KONUT DEĞER ENDEKS YÖNETİMİ',
    description3: 'Bu yöntemde tahsisat tarihiniz geldiğinde evinizin değeri korunmuş olur.',
    invalid_username_or_password: 'Kullanıcı adı veya şifre bilgisi yanlış'
  },
  vtreeselect: {
    placeholder: '',
    noresults: 'Kayıt bulunamadı'
  },
  errors: {
    500: 'İstek gönderilemedi. (500)',
    unknownloginerror: 'Giriş işlemi esnasında hata oluştu.',
    networkerror: 'Bağlantı hatası oluştu.',
    wrongTypeExcel: 'Yanlış excel tipi!',
    couldntFindAnyPayment: 'Ödenmesi gereken herhangi bir ödeme bulunamadı!',
    telecomContactMechException: 'Telefon numarasına ait bir kayıt bulunmakta!',
    hasActiveProcessException: 'Mevcut iletişim bilgileri değişikliği süreci vardır!',
    cannotEqualPrimaryPhoneNumberException: 'Birincil telefon numarası ile aynı telefon numarası girilemez',
    phoneNumberShouldBeEntered: 'Telefon numarası girilmeli!',
    lastNameShouldBeEntered: 'Soyadı girilmeli!',
    firstNameShouldBeEntered: 'İsim girilmeli!',
    provinceShouldBeEntered: 'İl seçilmeli!',
    districtShouldBeEntered: 'İlçe seçilmeli!',
    tooManyRequests: 'Çok fazla istekte bulunuldu. Lütfen bir süre sonra tekrar deneyeniz.'
  },
  errorPage: {
    title: 'Sayfa bulunamadı',
    description: 'Lütfen girdiğiniz sayfa adresinin doğru olup olmadığını kontrol ediniz. Ana sayfaya geri dönmek veya hata raporu göndermek için aşağıdaki düğmeyi tıklayın.',
    home: 'Ana sayfaya dön',
    right: 'Bu sayfayı görüntüleme izniniz yok',
    rightdescription: 'Bu sayfayı görüntelemeniz gerektiğini düşünüyor iseniz yetki talebinden bulununuz.',
    back: 'Geri dön',
    cancel: 'Silme işleminden Vazgeçildi'
  },
  notify: {
    mailNotValid: 'Geçerli bir e-mail adresi giriniz',
    validDateLate: 'Teklif geçerliliğini yitirmiştir.',
    minMaxNotValid: 'Minimum değer maksimum değerden büyük olamaz',
    AlreadyExistRevisionRequest: 'Ürüne tanımlanmış devam etmekte olan revizyon talebi bulunmaktadır.',
    CheckRevisionApproved: 'Aktif bir organizasyon ücreti indirimi mevcuttur. Revizyonu iptal ederek işleminize devam edebilirsiniz.',
    CheckPaymentStatusBeforeRevision: 'Geçmişte Ödenmemiş borcu olan finansman planı.Müşteri Geçmiş Borcunu Ödemeli veya Gecikmiş borcu için taksit atlatma almalı',
    TimeLimitRevisionRequest: 'Bir önceki revizyondan dolayı revizyon talebi eklenememiştir.',
    alreadyExist: 'Aynı özelliklere sahip kayıt tekrar eklenemez. Değiştirmek istediğiniz kaydı güncelleme ile düzeltebilirsiniz.',
    ProgramAlreadyExist: 'Aynı özelliklere sahip Tasarruf Programı tekrar eklenemez.',
    financeRangeOverleap: 'Finansman Tutar Aralığında tanımlı başka bir program bulunmakatadır. Farklı bir finansman aralığı girmeniz gerekmektedir.',
    maturityRangeOverleap: 'Vade Aralığında tanımlı başka bir program bulunmakatadır. Farklı bir vade aralığı girmeniz gerekmektedir.',
    DrawingTermRequired: 'Finansman Planı Sıra Tespit Tarihi girilmeden kapatılamaz.',
    intervalNotValid: 'Aralık hatalı.(Bu aralıkta başka bir değer olabilir.)',
    ProductNotFound: 'Kayıt bulunmadı',
    passwordSixDigits: 'Şifre 6 en az 6 karakter olmalıdır !',
    LaterThanDeliveryDate: 'Kura Sonucu Tahsisat Tarihinden önce olamaz',
    ProductStatusNotOK: 'Finansman Planı durumu uygun değil',
    AssignedDeliveryDate: 'Tahsisat Tarihi başka bir ürüne atanmış bulunmaktadır.',
    NotFound: 'İlgili kayıt bulunamadı',
    FirstInstallmentNotPayed: ' İlk taksit ödenmediğinden taksit atlatma yapılamaz',
    WorkingCostPostpone: 'Organizasyon Ücreti taksitleri için taksit atlatma yapılamaz.',
    NoCustomerFound: 'Bu programda herhangi bir müşteri kaydı bulunmamaktadır. Programı güncelleme veya silmeyi deneyiniz.',
    successUpdated: 'Başarı ile güncellenmiştir',
    error: 'İşlem sırasında hata oluştu!',
    unknownError: 'İşlem esnasında hata oluştu',
    notDone: 'İşlem iptal edildi.',
    saveChanges: 'Kaydet',
    approveRequired: 'Onay Bekleniyor iken işlem yapamazsınız!',
    discardChanges: 'Vazgeç',
    deleteRecord: 'SİL',
    deleteTitle: 'Kaydı silmek istediğinize emin misiniz ?',
    deleteText: 'Kayıt Silinecek !',
    deleteWarning: 'Silme Onayı',
    delete: 'Sil',
    success: 'Başarı ile kaydedilmiştir',
    deleteCancel: 'Vazgeç',
    deleteCanceled: 'Silme iptal edildi.',
    saleDone: 'Satışı Yap',
    saleCanceled: 'Satış iptal edildi.',
    deleteSuccess: 'Başarı ile kayıt silindi.',
    formtItemTitle: 'Etiket Giriniz',
    complate: 'Tamamla',
    requiredAreas: 'Gerekli alanları doldurunuz',
    warning: 'Hata',
    ok: 'Tamam',
    edit: 'Düzenle',
    cancel: 'Vazgeç',
    returnList: 'liste ekranına dönmek istediğine emin misin?',
    yes: 'Evet',
    no: 'Hayır',
    update: 'Güncelle',
    canceled: 'İptal edildi',
    youCantAddNewProjectToThisGroup: 'Bu finansman planı grubuna yeni kayıt eklenemez...',
    thisCustomerCardHasNoInvoiceHistory: 'Müşteriye ait fatura bulunmamaktadır',
    cannotSaleToCustomerDontHavePortfolio: 'Portföyü olmayan müşteriye satış yapılamaz'
  }
};
/* eslint-enable */